<template>
  <section v-if="items.length" class="meta-grid">
    <div v-for="item in items" :key="item.label" class="stat">
      <div class="value">{{ item.value }}</div>
      <div class="label">{{ item.label }}</div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'StationMeta',
  props: {
    items: { type: Array, default: () => [] },
  },
};
</script>

<style scoped>
.meta-grid {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  gap: var(--gap);
  min-height: 0;
}
.stat {
  border: 1px solid #e5e7eb;
  border-radius: var(--radius);
  background: #fff;
  padding: clamp(8px, 1.5vw, 14px);
  display: grid;
  place-items: center;
  text-align: center;
}
.value {
  font-size: clamp(18px, 2.2vw, 28px);
  font-weight: 600;
  color: #1f2937;
  line-height: 1.1;
}
.label {
  margin-top: 6px;
  font-size: clamp(10px, 0.9vw, 14px);
  color: #4b5563;
}
@media (max-width: 520px) {
  .meta-grid {
    grid-auto-flow: row;
    grid-auto-columns: auto;
  }
}
</style>
